"use strict";

exports.__esModule = true;
exports.getTodayDate = exports.getTimeSpan = exports.getEndOfDay = exports.formatDateToHuman = exports.YESTERDAY = exports.TODAY = exports.THIS_YEAR = exports.THIS_WEEK = exports.THIS_QUARTER = exports.THIS_MONTH = exports.LAST_YEAR = exports.LAST_WEEK = exports.LAST_QUARTER = exports.LAST_MONTH = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TODAY = exports.TODAY = 'TODAY';
const YESTERDAY = exports.YESTERDAY = 'YESTERDAY';
const THIS_WEEK = exports.THIS_WEEK = 'THIS_WEEK';
const LAST_WEEK = exports.LAST_WEEK = 'LAST_WEEK';
const THIS_MONTH = exports.THIS_MONTH = 'THIS_MONTH';
const LAST_MONTH = exports.LAST_MONTH = 'LAST_MONTH';
const THIS_QUARTER = exports.THIS_QUARTER = 'THIS_QUARTER';
const LAST_QUARTER = exports.LAST_QUARTER = 'LAST_QUARTER';
const THIS_YEAR = exports.THIS_YEAR = 'THIS_YEAR';
const LAST_YEAR = exports.LAST_YEAR = 'LAST_YEAR';
const getEndOfDay = date => {
  return (0, _moment.default)(date).add(23, 'hours').add(59, 'minutes').add(59, 'seconds').add(999, 'milliseconds');
};
exports.getEndOfDay = getEndOfDay;
const getTimeSpan = option => {
  let dateObject = {
    startDate: null,
    endDate: null
  };
  let startDate;
  let endDate;
  let actualDate = new Date();
  switch (option) {
    case TODAY:
      startDate = (0, _moment.default)(actualDate).startOf('day');
      endDate = new Date();
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
    case YESTERDAY:
      endDate = (0, _moment.default)(actualDate).startOf('day');
      startDate = (0, _moment.default)(endDate).subtract('days', 1);
      endDate = (0, _moment.default)(endDate).subtract('milliseconds', 1);
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
    case THIS_WEEK:
      startDate = (0, _moment.default)(actualDate).startOf('isoWeek');
      endDate = new Date();
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
    case LAST_WEEK:
      endDate = (0, _moment.default)(actualDate).startOf('isoWeek');
      startDate = (0, _moment.default)(endDate).subtract('weeks', 1);
      endDate = (0, _moment.default)(endDate).subtract('milliseconds', 1);
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
    case THIS_MONTH:
      startDate = (0, _moment.default)(actualDate).startOf('month');
      endDate = new Date();
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
    case LAST_MONTH:
      endDate = (0, _moment.default)(actualDate).startOf('month');
      startDate = (0, _moment.default)(endDate).subtract('months', 1);
      endDate = (0, _moment.default)(endDate).subtract('milliseconds', 1);
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
    case THIS_QUARTER:
      startDate = (0, _moment.default)(actualDate).startOf('quarter');
      endDate = new Date();
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
    case LAST_QUARTER:
      endDate = (0, _moment.default)(actualDate).startOf('quarter');
      startDate = (0, _moment.default)(endDate).subtract('months', 3);
      endDate = (0, _moment.default)(endDate).subtract('milliseconds', 1);
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
    case THIS_YEAR:
      startDate = (0, _moment.default)(actualDate).startOf('year');
      endDate = new Date();
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
    case LAST_YEAR:
      endDate = (0, _moment.default)(actualDate).startOf('year');
      startDate = (0, _moment.default)(endDate).subtract('years', 1);
      endDate = (0, _moment.default)(endDate).subtract('milliseconds', 1);
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
    default:
      //Today

      startDate = (0, _moment.default)(actualDate).startOf('day');
      endDate = new Date();
      dateObject.startDate = (0, _moment.default)(startDate).toISOString();
      dateObject.endDate = (0, _moment.default)(endDate).toISOString();
      return dateObject;
  }
};
exports.getTimeSpan = getTimeSpan;
const getTodayDate = format => {
  let date = new Date();
  let todayDate = (0, _moment.default)(date);
  return todayDate.format(format);
};
exports.getTodayDate = getTodayDate;
const formatDateToHuman = (ISODate, format) => {
  let todayDate = (0, _moment.default)(ISODate);
  return todayDate.format(format);
};
exports.formatDateToHuman = formatDateToHuman;